import React from 'react'
import { styled } from '@mui/material/styles'

const NoObservationText = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
  width: '150px',
  display: 'inline-block',
}))

const StyledText = styled('span')(({ theme }) => ({
  cursor: 'pointer',
  width: '150px',
  display: 'inline-block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:hover': {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
  },
}))

export const TruncatedObservation = ({ text, onClick }) => {
  if (!text || text === '--') {
    return <NoObservationText>--</NoObservationText>
  }

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <StyledText onClick={handleClick} title={`${text} - Clic para ver completo`}>
      {text}
    </StyledText>
  )
}
